import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <Logo size={36} />
              <span>Audra Books</span>
            </Link>
            <p className="footer-tagline">
              A polished Audiobookshelf client for iOS and Android.
              Your personal audiobook and ebook companion.
            </p>
          </div>

          <div className="footer-links-grid">
            <div className="footer-links-column">
              <h4>App</h4>
              <Link to="/">Home</Link>
              <Link to="/features">Features</Link>
              <a href="#download">Download</a>
            </div>

            <div className="footer-links-column">
              <h4>Legal</h4>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
            </div>

            <div className="footer-links-column">
              <h4>Connect</h4>
              <a href="https://github.com/RandallEric/AudraBooks-Feedback/issues" target="_blank" rel="noopener noreferrer">
                Feedback & Issues
              </a>
              <a href="mailto:support@audrabooks.app">Contact</a>
            </div>

            <div className="footer-links-column">
              <h4>For Server Owners</h4>
              <Link to="/shelfpulse">ShelfPulse</Link>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Audra Books. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
